<template>
  <modal :titulo="`Odin - Processamento de Matrícula - ${titulo}`" id="odin-processamento-ato"
         :fechar="true" @close="close" :loading="loading">

    <template  v-if="!loading">

      <!-- Esta tela é o motor ANTERIOR de análise; o atual é a Análise de Matrícula (Odin). O
           banner é permanente, inclusive no cartório que ligou `motorAntigoMatriculaAtivo`: é por
           ele que a Análise de Matrícula continua a um clique de distância.
           NÃO afirma POR QUE a matrícula está aqui, e isso é deliberado — são três caminhos até
           este modal e eles têm motivos diferentes. Pelo ícone da ficha
           (DetalhesIndicadorReal.odinMatricula) se chega com análise legada, a rampa, ou com a
           configuração do motor antigo ligada; pelo painel de acompanhamento
           (OdinAcompanhamentoMatriculas.imovel) se chega direto, sem consultar o motor. Texto que
           explicasse um dos motivos seria falso nos outros. -->
      <div class="banner-novo-motor">
        <div class="banner-novo-motor__info">
          <i class="fal fa-microchip-ai banner-novo-motor__icon"></i>
          <div class="banner-novo-motor__txt">
            <b>Esta é a análise anterior da matrícula</b>
            <span>A Análise de Matrícula (Odin) é o motor atual: análise completa e assíncrona da
              matrícula com IA — atos, indicador real, proprietários e mais.</span>
          </div>
        </div>
        <v-button :run="abrirMatriculaItnOdin" class="banner-novo-motor__cta"
                  title="Abrir a Análise de Matrícula (Odin) em outra aba">
          Abrir análise atual <i class="fal fa-arrow-up-right-from-square ml-1"></i>
        </v-button>
      </div>

      <card>
        <card-content>

          <p><span class="font-weight-500">{{titulo}}</span></p>
          <p><span class="font-weight-500">CNM: </span><span>{{ficha.cnm}}</span></p>
          <p v-if="ficha.livroLetra"><span class="font-weight-500">Livro (Letra): </span><span>{{ficha.livroLetra}}</span></p>
          <p><span class="font-weight-500">Último Ato: </span><span>{{ficha.ultimoAto}}</span></p>

          <hr/>

          <p><span class="font-weight-500">Atos Registrados no Sistema: </span>
            <span>{{dataBus.info.atosRegistrados}} [Códigos {{dataBus.info.menorAtoRegistrado}} até {{dataBus.info.maiorAtoRegistrado}}]</span></p>
          <p><span class="font-weight-500">Atos Marcados como Validados: </span><span>{{dataBus.info.atosValidados}}</span></p>
          <p><span class="font-weight-500">Atos Sem Texto: </span><span>{{dataBus.info.atosSemTexto}}</span></p>
          <p><span class="font-weight-500">Digitalizações: </span>
            <span>{{dataBus.info.digitalizacoes}}
              <router-link :to="{ name: 'digitalizacao', params: { id: indicadorRealId, entidade : 'INDICADOR_REAL', tipoEntidade : 'INDICADOR_REAL' }}"
                           target="_blank" title="Digitalização">
                <i class="fal fa-file-image"></i>
              </router-link>
            </span></p>
          <p><span class="font-weight-500">Digitalizações Sem OCR: </span><span>{{dataBus.info.digitalizacoesSemOcr}}</span></p>

        </card-content>
      </card>

<!--      <template v-if="activeTab === 'ocr' && dataBus.info.digitalizacoesSemOcr > 0">-->

<!--        <div class="alert alert-outline-danger my-2 w-100">-->
<!--          Necessário realizar o OCR das digitalizações antes de dar continuidade.-->
<!--          <div class="w-100"></div>-->

<!--          <v-button v-if="!['PROCESSING', 'WAITING'].includes(dataBus.info.statusOcr)"-->
<!--                    class="btn btn-outline-primary btn-sm mt-2" :run="runOcr" :popover="true">-->
<!--            Agendar OCR-->
<!--          </v-button>-->
<!--          <span v-else>Processo em andamento</span>-->

<!--        </div>-->

<!--      </template>-->

      <card class="border-transparent">

        <template #acoes>
          <ul class="nav nav-tabs">
            <li class="nav-item" v-for="menu in menus" :key="menu.id">
              <a class="nav-link" :class="{ active: activeTab === menu.id }"
                 href="#" @click.prevent="activeTab = menu.id">
                {{menu.nome}}
              </a>
            </li>
          </ul>
        </template>

        <card-content id="conteudo-processamento">
          <odin-indicador-real-ocr-processamento :data-bus="dataBus" v-if="activeTab === 'ocr'" :indicador-real-id="indicadorRealId" :textoLegado="textoLegado" />
          <odin-indicador-real-atos-processamento :data-bus="dataBus" v-if="activeTab === 'atos'" :indicador-real-id="indicadorRealId" />
        </card-content>

      </card>

    </template>

    <template #footer>
      <v-button v-if="activeTab === 'atos'" :run="analisar" :params="[true]" class="btn-outline-primary ml-auto">Analisar Situação Jurídica</v-button>
    </template>

  </modal>
</template>

<script>

import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import Modal from "@/components/Modal.vue";
import FrontBusiness from "@/business/FrontBusiness";
import OdinIndicadorRealAtosProcessamento from "@/views/Odin/modais/componentes/OdinIndicadorRealAtosProcessamento.vue";
import OdinIndicadorRealOcrProcessamento from "@/views/Odin/modais/componentes/OdinIndicadorRealOcrProcessamento.vue";
import ModalOdinAnaliseSituacaoJuridica from "@/views/Odin/modais/componentes/ModalOdinAnaliseSituacaoJuridica.vue";

export default {
  name: 'ModalOdinProcessamentoMatricula',
  components: {
    OdinIndicadorRealAtosProcessamento,
    OdinIndicadorRealOcrProcessamento,
    Card, CardContent, Modal},
  props:{
    indicadorRealId: String,
    textoLegado: Boolean
  },

  modal: {
    width: 1200
  },
  async mounted() {
    this.load();
  },

  data(){
    return {
      activeTab: "ocr",
      menus: [
        {id: 'ocr', nome: 'Leitura do OCR'},
        {id: 'atos', nome: 'Atos Cadastrados'},
      ],
      loading: true,
      dataBus: {
        info: null,
        ficha: null,
      }
    }
  },

  computed:{
    titulo(){
      return this.ficha?.livro ? FrontBusiness.nomearFicha(this.ficha) : '';
    },
    ficha(){
      return this.dataBus.ficha;
    },
  },

  methods:{
    async close(retorno) {
      FrontBusiness.closeModal(retorno);
    },

    async load(){

      const p1 = IndicadorRealBusiness.getById(this.indicadorRealId)
        .then(r => this.$set(this.dataBus, 'ficha', r));

      const p2 = this.$api.get(`api/odin/acompanhamento-matriculas/${this.indicadorRealId}`)
        .then(r => this.$set(this.dataBus, 'info', r));

      // const p3 = this.statusOcr();

      await Promise.all([p1, p2]);

      this.loading = false;
    },

    // async statusOcr(){
    //   // return TextExtractorBusiness.getStatus('ocr-digitalizacoes-matricula', this.indicadorRealId)
    //   //   .then(r => this.$set(this.dataBus, 'statusOcr', r));
    // },

    // async runOcr(){
    //   this.$set(this, 'loading', true);
    //   await FrontBusiness.openModal(SeeModal, {titulo : 'OCR Matrícula', url : TextExtractorBusiness.ocrMatricula(this.indicadorRealId)});
    //   await this.load();
    // },

    showError(e) {
      FrontBusiness.showError('', e.message);
    },

    async analisar() {
      const ret = await FrontBusiness.openModal(
        ModalOdinAnaliseSituacaoJuridica,
        { indicadorRealId: this.indicadorRealId }
      );
      if(ret) {
        await this.load();
      }
    },

    abrirMatriculaItnOdin() {
      // Abre a view dedicada da Análise de Matrícula (Odin) em nova aba, focada nesta matrícula.
      // Mantém este modal aberto para o usuário não perder o contexto atual.
      const route = this.$router.resolve({ name: 'odin-matricula-itn-odin', params: { indicadorRealId: this.indicadorRealId } });
      window.open(route.href, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
/* Convite (VHL) para o novo motor de Análise de Matrícula — banner no topo do modal */
.banner-novo-motor {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(109, 94, 252, .35);
  background: linear-gradient(135deg, rgba(109, 94, 252, .12), rgba(139, 127, 253, .06));

  &__info { display: flex; align-items: center; gap: 12px; min-width: 0; }
  &__icon { font-size: 22px; color: #6d5efc; flex: 0 0 auto; }
  &__txt {
    display: flex; flex-direction: column; gap: 2px;
    // Cores explícitas (o banner fica fora do card, não herda a cor de texto do conteúdo).
    b { font-size: 13.5px; font-weight: 700; display: inline-flex; align-items: center; color: #2a2250; }
    span { font-size: 12px; color: #4b5162; }
  }
  &__badge {
    margin-left: 8px; font-size: 9.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em;
    color: #fff; background: linear-gradient(135deg, #6d5efc, #8b7ffd);
    padding: 1px 7px; border-radius: 999px;
  }
  &__cta {
    flex: 0 0 auto; display: inline-flex; align-items: center;
    background: linear-gradient(135deg, #6d5efc, #8b7ffd); border: none; color: #fff !important;
    font-weight: 600; box-shadow: 0 3px 10px rgba(109, 94, 252, .3);
    &:hover { filter: brightness(1.06); }
  }
}

/* Tema escuro: o banner fica fora do card; garante contraste do texto no dark. */
body.theme-dark .banner-novo-motor {
  border-color: rgba(139, 127, 253, .4);
  background: linear-gradient(135deg, rgba(109, 94, 252, .2), rgba(139, 127, 253, .08));
  .banner-novo-motor__icon { color: #a99dff; }
  .banner-novo-motor__txt b { color: #eceef3; }
  .banner-novo-motor__txt span { color: #c3c8d3; }
}
</style>
